import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const GiftVoucherList = lazy(() => import("../components/GiftVoucherList"));

const GiftVoucherListConfigRoute: RouteObject = {
  path: "/gift-vouchers",
  element: <GiftVoucherList />,
};

export default GiftVoucherListConfigRoute;
